<template>
    <div :data-component="$options.name">
        <cs-modal
            :visible="isVisible"
            :headerText="'Anrufen'"
            @update:visible="emitClosedModalEvent"
        >
            <p
                data-jest-headline
                class="text-text-l font-bold mb-16"
            >
                {{ contact.isCommercialExpose ? contact.title : contact.name }}
            </p>
            <div
                v-for="(number, index) in contact.contactNumbers"
                :key="number.label"
                class="text-text-l"
                data-jest-number
            >
                <template v-if="number.label === ContactNumberType.PHONENUMBER">
                    <p :class="{ 'mb-16': index < contact.contactNumbers?.length - 1 }">
                        Festnetz:
                        <cs-copy-text-link
                            :href="`tel:${number.value}`"
                            @click="trackMlm"
                            >{{ number.value }}</cs-copy-text-link
                        >
                    </p>
                </template>
                <template v-if="number.label === ContactNumberType.MOBILENUMBER">
                    <p :class="{ 'mb-16': index < contact.contactNumbers?.length - 1 }">
                        Mobil:
                        <cs-copy-text-link
                            :href="`tel:${number.value}`"
                            @click="trackMlm"
                            >{{ number.value }}</cs-copy-text-link
                        >
                    </p>
                </template>
                <template v-if="number.label === ContactNumberType.FAXNUMBER">
                    <p>Fax: {{ number.value }}</p>
                </template>
            </div>
        </cs-modal>
    </div>
</template>
<script lang="ts" src="./MsDetailModalCall.ts" />
